import api from '@api';
import { withArchive } from 'src/resources/withArchive';

const getFileData = async (id: number, archive?: boolean): Promise<string> => {
    const res: { data: string } = await api('get', withArchive(`api/secure/files/${id}`, archive));
    return res.data;
};

export default getFileData;
